<template>
<div id="it1024im" style="height: 100%;">
    <!-- 头部组件 -->
    <!-- <component :is="header_"></component> -->
    
    <div class="it1024im">
    <!--  -->
    <el-container class="el-container-box" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <!-- <component :is="celan"></component> -->
      

      <!-- 主体 -->
      <el-main>
      <div id="container">
        <div class="it1024im-header">
          <span @click="back()" class="it1024im-chat-back"></span>
          <!-- <div style="display: inline-block;">在线咨询</div> -->
        </div>
        <div id="it1024im_section" style="background: #ebebeb;">

          <div id="container_">
            <!-- <div class='it1024im-window-title'>在线咨询</div> -->
            <div id="container_val">
              <div v-for="it1024im_ in it1024im">
               <!-- 游客 -->
               <div v-if="it1024im_.type=='fangke'?true:false" class="fangke" style="clear:both;float: left;position: relative;">
                  <p style="float:right;">
                    <span class="fangketitle">
                       访客&nbsp;&nbsp;{{it1024im_.time}}
                    </span>
                    <span class="fangkeval" v-html="it1024im_.content">
                        <!-- {{it1024im_.content}} -->
                    </span>
                  </p>
                    <img style="width:39px;float:left;margin-top:19px;margin-right: 10px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'">
               </div>
               <!-- 客服 -->
               <div v-if="it1024im_.type=='kefu'?true:false" class="myhuifu" style="clear:both;float: right;position: relative;">
                  <p style="float:left;">
                     <span class="kefutitle">
                        {{it1024im_.time}}&nbsp;&nbsp;客服
                     </span>
                     <span class="kefuval" v-html="it1024im_.content">>
                         <!-- {{it1024im_.content}} -->
                     </span>
                  </p>
                  <img style="width:39px;float:right;margin-top:19px;margin-left: 10px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-kefuimg.png'">
               </div>
              </div>


            </div>

          </div>
       


        </div>
        <div class="it1024im-footer">
            <!-- 输入框和按钮 -->
            <div class="it1024im-chat-footer">
              <textarea v-model="textarea_val" @keyup.enter="btn()" style="resize:none;outline:none;padding: 4px 4px 0px;" rows="3" cols="20" class="it1024im-window-textarea" placeholder="" /></textarea>
              <input @click="btn" type="button" class="it1024im-window-button" value="发送" />
            </div>
        </div>
      </div>    
        
      </el-main>

    </el-container>
    </div>

</div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
//头部组件
import header_ from './header_.vue'    
import celan from './celan.vue'    
export default {
    name: 'it1024im',
    data() {
      return {
        header_: header_,
        celan: celan,
        textarea_val: '',
        it1024im:[],
        it1024im_id:[],
        userid_number:[],
        ImUserid:'',
        it1024imURL: global.it1024imURL,
        posturl: global.it1024imUrl,
      }
    },
    methods: {
       back(){
           //停止定时器
           clearInterval(this.setInter);
           //路由跳转
           this.$router.push({path:'/mobile'});
       },  
       btn(){
          
          if(this.textarea_val.replace(/^\s+$/g,"") == ''){
             this.$notify({
                title: '提示',
                message: '请输入内容',
                type: 'warning'
             });
          }else{ 
            //时间
            var newDate_ = new Date();
            var time_ = newDate_.getFullYear() + '-' + (newDate_.getMonth() + 1) + '-' + newDate_.getDate() + ' ' + newDate_.getHours() + ':' + newDate_.getMinutes() + ':' + newDate_.getSeconds();

            var ImUserid = localStorage.getItem("ImUserid"); //取

            //使用正则替换<>'
            var replace1 = this.textarea_val.replace(/</g,"&lt;");
            var replace2 = replace1.replace(/>/g,"&gt;");
            this.textarea_val = replace2.replace(/'/g,"’");

            //data
            var objim = {
                avatar: "",
                content: this.textarea_val,
                userid: ImUserid,
                state: false,
                time: time_,
                type: "kefu",
                username: "客服"
              };
            
              this.it1024im.push(objim);
              //让滚动条一直处于聊天窗口底部
              this.$nextTick(function () {
                  var it1024im_section = document.getElementById('it1024im_section');
                  it1024im_section.scrollTop = it1024im_section.scrollHeight;
              });
              //发送完成后清空输入框
              this.textarea_val = '';
              //提交数据
              this.$http.post(this.posturl,{objim:objim},{emulateJSON:true}).then(res=>{
                    if(res.body){
                        // console.log(res.body);
                        this.it1024im.push(res.body);
                    }else{
                        //提示消息
                        this.$notify.error({
                          title: '提示',
                          message: '信息发送失败'
                        });
                    }
              });

          };
       }      
    },
    created (){

    },
    mounted() {
      var ImUserid = localStorage.getItem("ImUserid"); 
      //请求数据
      this.setInter = setInterval(()=>{
          if(ImUserid != null){
            this.$http.post(this.posturl,{chatdata:ImUserid},{emulateJSON:true}).then(res=>{
               // this.it1024im=res.body;
               //把聊天数据存到本地存储
               localStorage.setItem("IT1024IM",JSON.stringify(res.body)); 

            });
           };

          //读取本地聊天存储数据
          var it1024im = JSON.parse(localStorage.getItem("IT1024IM"));
          var array=[];
          for(var i=0;i<it1024im.length;i++){
            if (it1024im[i].userid==ImUserid) {
              array.push(it1024im[i]);     
            };
          };
          this.it1024im=array;

          //聊天窗口滚动到底部
          var It1024imDataLengths = localStorage.getItem("It1024imDataLengths");
          if (array.length > It1024imDataLengths) {
             localStorage.setItem("It1024imDataLengths",array.length); 
             //让滚动条一直处于聊天窗口底部
             this.$nextTick(function () {
              var it1024im_section = document.getElementById('it1024im_section');
              it1024im_section.scrollTop = it1024im_section.scrollHeight;
             });
          };

           //设置已读
           this.$http.post(this.posturl,{userid:ImUserid,ReadId:ImUserid},{emulateJSON:true}).then(res=>{
               console.log("已读2");
               // console.log(res.body)
               // this.it1024im=res.body;
           });


      },1000);

      //读取本地存储数据
      var it1024im = JSON.parse(localStorage.getItem("IT1024IM"));
      for(var i=0;i<it1024im.length;i++){
        if (it1024im[i].userid==ImUserid) {
          this.it1024im.push(it1024im[i]);
        };
      };


    }
  }
</script>


<style scoped>
*{ 
  margin:0;
  padding: 0;
}
html,body {
    width: 100%;
    height: 100%;
}
ul{
    list-style-type: none
}
.el-container-box,#it1024im,.it1024im {
    width: 100%;
    height: 100%;
}
.it1024im-Unread-messages {
    background: #ff4444;
    color: #fff;
    font-size: 12px;
    border-radius: 53%;
    margin-left: 4rem;
    width: 1.5rem;
    display: inline-block;
    text-align: center;
    overflow: hidden;
}
.it1024im-window-textarea{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    height: 40px;
    border: 0;
    background-color: #fff;
    border-radius: 3px;
    margin-left: 3px;
}
.it1024im-window-button{
    border-radius: 3px;
    padding: 7px;
    border: 0;
    margin-left: 7px;
    margin-right: 3px;
    background-color: #009688;
    color: #fff;
}
.it1024im-chat-back{
    display: inline-block;
    width: 0.6rem;
    height: 0.6rem;
    border: 0.1rem solid #fff;
    border-bottom: none;
    border-right: none;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    background: transparent !important;
    margin-left: 1rem;
}
.it1024im-chat-footer {
    display: flex;
    justify-content: space-around;
    text-align: center;
}
#it1024im_section ul li {
    padding: 7px;
    background: #efefef;
    margin: 2px;
    border-radius: 3px;
    cursor: pointer;
}
#it1024im_section ul li img{
    vertical-align: middle;
    border-style: none;
    width: 38px;
    border-radius: 50%;
}
#container {
    display: flex;
    height: 100%;
    flex-direction: column;
}
.it1024im-header {
    background: #6793e0;
    width: 100%;
    z-index: 99;
    height: 3rem;
    line-height: 3rem;
    font-size: 1.3rem;
}
#it1024im_section {
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow: auto;
    -moz-overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.it1024im-footer {
    width: 100%;
    background: #ebebeb;
}
.it1024im-footer ul {
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: baseline;
}
#container_val {
    padding: 0.5rem;
}
.kefutitle,.fangketitle{
    color:#999;
    font-size:13px;
    margin-bottom:5px;
    display:block;
    float:right;
    margin-right: 8px;
}
.fangketitle{
    float: left;
    margin-left: 8px;
}
.myhuifu, .fangke {
    padding-bottom: 1rem;
    padding-top: 1rem;
}
.kefuval, .fangkeval {
   display: block;
    word-break: break-all;
    clear: both;
    background: rgb(103, 147, 224);
    padding: 8px 15px;
    border-radius: 5px;
    color: white;
    max-width: 230px;
    margin-right: 8px;
}
.fangkeval{
  background:#009688;
  margin-left: 8px;
}
.fangkeval:after {
    content: '';
    position: absolute;
    top: 55px;
    left: 47px;
    width: 0;
    height: 0;
    border-style: solid dashed dashed;
    border-color: #009688 transparent transparent;
    overflow: hidden;
    border-width: 10px;
}
.kefuval:after {
    content: '';
    position: absolute;
    top: 55px;
    right: 47px;
    width: 0;
    height: 0;
    border-style: solid dashed dashed;
    border-color: #6793e0 transparent transparent;
    overflow: hidden;
    border-width: 10px;
}

@media screen and (width: 320px) {
 .kefuval,.fangkeval{
    width: 11.7rem !important;
 }
}

@media screen and (width: 375px) {
 .kefuval,.fangkeval{
    width: 15.2rem !important;
 }
}

@media screen and (width: 414px) {
 .kefuval,.fangkeval{
    width: 17.6rem !important;
 }
}

@media screen and (width: 768px) {
 .kefuval,.fangkeval{
    width: 20rem !important;
 }
}

@media screen and (width: 1024px) {
 .kefuval,.fangkeval{
    width: 27.8rem !important;
 }
}

</style>


// WEBPACK FOOTER //
// src/components/mobilechat.vue